/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Body_PlaceholderInputs */

const en_messages_body_placeholder = /** @type {(inputs: Messages_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const he_messages_body_placeholder = /** @type {(inputs: Messages_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעה`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Messages_Body_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_body_placeholder = /** @type {((inputs?: Messages_Body_PlaceholderInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Body_PlaceholderInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_body_placeholder(inputs)
	return he_messages_body_placeholder(inputs)
});